// Set up the environment variables based on the context
const env = typeof document === "undefined" ? process.env : window.ENV;

// Set the appropriate Sanity configuration based on the environment
export const config = {
  projectId: "50q6fr1p",
  apiVersion: "2021-03-25",
  dataset: env.SANITY_DATASET || "production",
  useCdn: env.MODE === "production",
};
